import styled from 'styled-components';

export const Print = styled.button`
  height: 30px;
  width: 30px;
  border-radius: 50%;
  align-self: center;
  float: right;
  position: absolute;
  clear: both;
  right: 0;
  margin-right: 10px;
  border: none;
  background: #f0b402;

  :hover {
    filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.2));
    border: solid grey 1px;
    border-radius: 50%;
  }
`;

export const DisplayNoneImprimir = styled.div`
  display: none;

  @media print {
    display: block;
  }
`;
export const ButtonCancel = styled.button`
  color: #ff2c3a;
  background-color: transparent;
  border: none;
  text-decoration: underline;
  font-weight: bold;
`;

export const CardContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 8px;
  padding-bottom: 8px;
  flex-direction: column;

  &:not(:first-child) {
    padding-top: 8px;
  }

  &:not(:last-child) {
    border-bottom: 1px solid #cdcdcd;
  }
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  align-self: flex-start;

  svg {
    cursor: pointer;
  }
`;

export const CardColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-self: stretch;
  gap: 5px;

  ${(props) => props.grow && 'flex-grow: 1;'}
`;

export const CardColumnItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const TableNumber = styled.span`
  font-size: 18px;
  font-weight: 600;
  line-height: 21px;
  text-align: left;
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: #f6f6f6;
  padding: 5px;
  border-radius: 5px;
`;

export const CardBody = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const DateArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;

  strong {
    font-weight: 600;
  }
`;
export const BillInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const DeliveryInfo = styled.div`
  display: flex;
  padding: 4px 8px;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background: var(--Takeat-Colors-Neutrals-White-02, #f6f6f6);

  span {
    color: var(--Takeat-Colors-Neutrals-Grey-01, #545454);

    /* Label/Label Medium/Medium | 500 */
    font-family: Poppins;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px; /* 133.333% */
    letter-spacing: 0.5px;
  }
`;

export const DeliveryTime = styled.span`
  color: var(--Takeat-Colors-Neutrals-Grey-01, #545454);

  /* Label/Label Medium/Semibold | 600 */
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px; /* 133.333% */
  letter-spacing: 0.5px;
`;

export const NameClient = styled.span`
  color: var(--Takeat-Colors-Neutrals-Black-01, #222);
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  align-self: stretch;
`;

export const PhoneClient = styled.span`
  color: var(--Takeat-Colors-Neutrals-Black-01, #222);
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  align-self: stretch;
`;

export const InfoClientDelivery = styled.span`
  color: var(--Takeat-Colors-Neutrals-Black-01, #222);
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  align-self: stretch;
`;
